export interface Feature {
  id: string;
  icon: string;
  title: string;
  description: string;
}

export const features: Feature[] = [
  {
    id: 'feature-1',
    icon: 'ri-database-2-line',
    title: '智能数据处理',
    description: 'mrds 采用先进的智能算法，支持多源数据的高效整合、清洗与分析，帮助您从海量数据中快速提取有价值的洞察，驱动业务决策。',
  },
  {
    id: 'feature-2',
    icon: 'ri-flow-chart',
    title: '自动化工作流',
    description: 'mrds 提供可视化工作流设计器，无需编写代码即可构建复杂的自动化流程，将重复性任务交给 mrds 自动完成，大幅提升团队效率。',
  },
  {
    id: 'feature-3',
    icon: 'ri-team-line',
    title: '实时团队协作',
    description: 'mrds 支持多人实时在线协作，团队成员可以同步编辑、即时沟通，所有操作记录完整可追溯，让远程协作如同面对面一样高效。',
  },
  {
    id: 'feature-4',
    icon: 'ri-bar-chart-2-line',
    title: '数据可视化分析',
    description: 'mrds 内置丰富的可视化组件库，支持数十种图表类型和交互式仪表盘，让复杂数据一目了然，为决策提供直观可靠的数据支撑。',
  },
  {
    id: 'feature-5',
    icon: 'ri-shield-check-line',
    title: '企业级安全保障',
    description: 'mrds 采用多层安全防护体系，包括数据加密传输、细粒度权限管控和操作审计追踪，全面保障您的数据安全和业务合规。',
  },
  {
    id: 'feature-6',
    icon: 'ri-smartphone-line',
    title: '多端无缝同步',
    description: 'mrds 全面支持桌面端、移动端和平板设备，所有数据实时同步，让您随时随地都能高效工作，不受设备和场景的限制。',
  },
];